/* eslint-disable */
export default {
  onSearching: '正在加载…',
  noContacts: '未找到记录。',
} as const;

// @key: @#@"onSearching"@#@ @source: @#@"Loading..."@#@
// @key: @#@"noContacts"@#@ @source: @#@"No records found."@#@
